const winston = require('winston');

module.exports = function buildConsoleTransport(logFormat = 'json', level = 'info', logApplication = '') {
    let formatOfLog;

    switch (logFormat) {
    case 'json':
        formatOfLog = winston.format.json();
        break;
    case 'logstash':
        formatOfLog = winston.format.printf((info) => {
            return JSON.stringify({
                level: info.level,
                message: info.message,
                '@timestamp': info.timestamp,
                application: logApplication
            });
        });
        break;
    default:
        formatOfLog = winston.format.simple();
        break;
    }
    const format = winston.format.combine(
        winston.format.timestamp(),
        formatOfLog
    );

    return new winston.transports.Console({
        level,
        format,
        colorize: true,
        handleExceptions: true
    });
};
